import { cva } from '@/styled-system/css';

export const upsellMediaRecipe = cva({
  base: {
    'display': 'flex',
    'justifyContent': 'center',
    'flexShrink': 0,

    '& > [data-c11n-component="Icon"]': {
      color: 'inherit',
      width: 'icon.xl',
      height: 'icon.xl',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'Upsell.Media.neutral.icon',
      },
      soft: {
        color: 'Upsell.Media.soft.icon',
      },
      hero: {
        color: 'Upsell.Media.hero.icon',
      },
      impact: {
        color: 'Upsell.Media.impact.icon',
      },
    },
  },
});
